<template>
  <nut-uploader :multiple="false" :maximum="limit" :accept="accept"
                @delete="handleUploadImageRemove"
                @success="handleImageUploadSuccess"
                :maximize="1024 * 1024 * 20"
                :is-preview="false"
                :before-xhr-upload="uploadRequest">
    <slot/>
  </nut-uploader>
</template>

<script>
import api from "@/api";

export default {
  name: "CustomOssUploader",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    files: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      uploading: false,
      uploaded:[],
    }
  },
  methods: {
    uploadRequest(xhr, options) {
      let file = options.sourceFile; // 拿到 file
      // 上传文件
      api.uploadFile({files:file}).then(res=>{
        const result = {
          name:res[0].filename,
          url:res[0].realname
        }
        options.onSuccess(result)
      }).catch(err=>{
        console.log("err",err)
        options.onError("上传失败")
      })
    },
    handleImageUploadSuccess(resp) {
      // console.log('上传成功1个文件', resp.responseText);
      this.uploaded.push(resp.responseText.url);
      this.$emit('onUploadedFiles', this.uploaded);
    },
    handleUploadImageRemove(del) {
      this.uploaded.splice(del.index, 1);
      this.$emit('onUploadedFiles', this.uploaded);
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>